<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('audit_request')" :icon="'user-check'"/>
            </div>
        </div>

        <div class="row">
            <auditrequest-datatable></auditrequest-datatable>
        </div>
    </div>
</template>

<script>

    import datatable from "../AuditRequest/Datatable";

    export default {
        name: "User",
        components: {
            datatable
        },
    } 
</script>
